exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".txt-blue[_v-fc6de74e]{color:#00e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-fc6de74e&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/brands/index.vue
// module id = 377
// module chunks = 0